import React, { useState, useEffect } from "react";
import RoleForm from "./form";
import Datatables from "../../../utils/table/datatable";
import { RoleColumns } from "helpers/DatatableColumns";
import { ROLE } from "helpers/url_helper";
import { get } from "helpers/api_helper";

const Roles = () => {
    const [isForm, setIsForm] = useState(false);
    const [roles, setRoles] = useState([])
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        search: '',
    })

    const toggleForm = () => {
        setIsForm(!isForm);
        if(isForm == false){
            getAllRoles();
        }
    }

    const getAllRoles = async () => {
        const { success, data } = await get(`${ROLE}?limit=${pagination.limit}&page=${pagination.page}&search=${pagination.search}`);
        if (success) {
            setRoles(data);
        }
    }

    useEffect(() => {
        getAllRoles();
    }, [pagination]);


    return (
        isForm ? <RoleForm cb={toggleForm} /> :
            <Datatables
                isSearch={true}
                columns={RoleColumns}
                showTableOnly={true}
                rowsLength={roles?.totalRows || 0}
                rows={roles?.data || []}
                keyField={'id'}
                handleAddButton={toggleForm}
                title="All Roles"
                loading={false}
                isAdd={true}
                isTableHead={true}
                ssr={(page) => setPagination(page)}
            />
    );
};

export default Roles;